<template>
  <div>
    <div v-if="!item" class="example3">
      <a-spin />
    </div>
    <fo-layout v-else>
      <div class="publication-dtl">
        <p class="pages-return-btn">
          <span @click="$router.push('/practice/publication')"><a-icon type="left" /> Back</span>
        </p>
        <a-row :gutter="50">
          <a-col :sm="16">
            <h1 class="page-title">{{item.article_title}}</h1>
          </a-col>
        </a-row>
        <a-row :gutter="50">
          <a-col :sm="16">
            <div class="subtitle down-solid">
              <span v-if="item.article_atime">{{item.article_atime.split(' ')[0]}}</span>
              <span>Author: {{item.article_author}}</span>
              <span>{{item.article_business_title_zh}}</span>
              <span>{{item.article_industry_title_zh}}</span>
            </div>
            <div class="content-html" v-html="item.article_content"></div>
          </a-col>
          <a-col :sm="8">
            <div class="down-solid">
              <div class="silver ta-c content-more-title">Other Articles</div>
            </div>
            <ul class="cases-list">
              <template v-for="(articleItem, ind) in articleData">
                <li :key="ind" v-if="ind < 3">
                  <cardCase
                    :title="articleItem.article_title"
                    :info="articleItem.article_content"
                    :author="articleItem.article_author"
                    @click="$router.push('./' + articleItem.code)">
                  </cardCase>
                </li>
              </template>
            </ul>
          </a-col>
        </a-row>
      </div>
    </fo-layout>
  </div>
</template>

<script>
import cardCase from './comps/cardCasesB.vue'
export default {
  components: {
    cardCase
  },
  data () {
    return {
      articleData: [], // 文章列表
      item: {},
      cond: {
        page_num: '1',
        page_size: '4'
      }
    }
  },
  mounted () {
    this.readList()
    this.readDtl()
  },
  watch: {
    '$route.params.param' () {
      this.readList()
      this.readDtl()
    }
  },
  methods: {
    readList () {
      this.loading = true
      this.get({
        url: 'articleRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        this.articleData = res.data.items.filter(item => item.code !== this.$route.params.param)
      })
    },
    readDtl () {
      this.get({
        url: 'articleFind',
        data: {
          code: this.$route.params.param
        }
      }, (res) => {
        this.item = res.data
      })
    }
  }
}
</script>

<style lang="less">
  @import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .publication-dtl {
    .page-title {
      font-weight: bold;
      font-family: Georgia, 宋体;
      margin-bottom: 20px;
    }
    .subtitle {
      margin-bottom: 30px;
      span {
        margin-right: 20px;
      }
    }
    .down-solid {
      width: 100%;
      border-bottom: 1px solid @graydark;
      font-size: 16px;
      .content-more-title {
        text-align: left;
        margin: 30px 0 20px;
      }
    }
    .cases-list {
      li {
        list-style-type: none;
        border-bottom: 1px solid @graydark;
        padding: 30px 0;
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .publication-dtl {
    .page-title {
      font-weight: bold;
      font-family: Georgia, 宋体;
      margin-bottom: 20px;
    }
    .subtitle {
      margin-bottom: 30px;
      span {
        margin-right: 20px;
      }
    }
    .down-solid {
      width: 100%;
      border-bottom: 1px solid @graydark;
      height: 40px;
      font-size: 16px;
    }
    .cases-list {
      li {
        list-style-type: none;
        border-bottom: 1px solid @graydark;
        padding: 30px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/publicationDtl.vue